module.exports = __webpack_public_path__ + "static/media/ic_render.9d52f6fd.svg";